import { Link } from "react-router-dom";


const Savedamt = () => {
  return (
    <section>
      <div className="container-fluid">
        <div className="row">
        

          <div className="col-lg-10 mt-3 mb-3">
            <div className="row">
              <div className="col-lg-1 text-end">
                <Link to="/">
                  <h6>
                    <i class="fa fa-home" aria-hidden="true"></i>Home
                  </h6>
                </Link>
              </div>
              /
              <div className="col-lg-5">
                <h6>Packages</h6>
              </div>
            </div>

            <div className="row">
              <div className="card border-0 shadow ">
                <div className="card-header bg bg-info border-0">
                  <h4>Packages Amounts View</h4>
                </div>

                <div className="card-body text-center">
                  <div className="col-lg-10 ">
                    <div className="row ">
                      {/* =======================Basic Saved Amount start================= */}

                      {/* <div className="col-lg-3 mt-3">
                        <div className="card border border-3 rounded-3 text-center bg bg-warning text-white">
                          <div className="card-header  border-0">
                            <h5 className=" mt-4">Basic Saved Amount</h5>

                            <h3 className=" mt-3">
                              <i className="fa fa-eye" aria-hidden="true"></i>{" "}
                              Rs 89,265
                            </h3>
                          </div>
                        </div>
                      </div> */}

                      {/* =======================Basic Saved Amount end================= */}

                      {/* =======================Premium Saved Amount start================= */}

                      <div className="col-lg-3 mt-3">
                        <div className="card border border-3 rounded-3 text-center bg bg-warning text-white">
                          <div className="card-header  border-0">
                            <h5 className=" mt-4">Premium Saved Amount</h5>

                            <h3 className=" mt-3">
                              <i className="fa fa-eye" aria-hidden="true"></i>{" "}
                              Rs 89,265
                            </h3>
                          </div>
                        </div>
                      </div>
                      {/* =======================Premium Saved Amount end================= */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Savedamt;
